import { eventChannel, END } from "redux-saga"
import { getAccessToken } from "app/localStorage/token"

export function createSocketChannel(socket: any) {
  return eventChannel(emit => {
    socket.on("message", (msg: any) => {
      emit(msg)
    })
    return () => {
      socket.disconnect()
      emit(END)
    }
  })
}

// A socket that reconnects is in no room, so join again on every connect.
// The server answers a join with the current data, which also catches up on missed updates.
export function joinRoom(socket: any, payload: unknown) {
  const join = () => socket.emit("message", { token: getAccessToken()!, payload })
  socket.on("connect", join)
  if (socket.connected) join()
}

// For sagas whose "connected" flag drives a loading state (Templates): keep it on until the socket is up,
// as before createWebSocketConnection stopped waiting for the first connect
export function whenConnected(socket: any): Promise<void> {
  return socket.connected ? Promise.resolve() : new Promise(resolve => socket.once("connect", () => resolve()))
}

export type ConnectionStatus = "connecting" | "connected" | "disconnected"

// Connection state for the Live/Offline indicator (DKT-58). Separate from the message channel, whose
// consumers expect only data. Closing it stops listening; the message channel owns the disconnect.
export function createStatusChannel(socket: any) {
  return eventChannel<ConnectionStatus>(emit => {
    const connected = () => emit("connected")
    const disconnected = () => emit("disconnected")
    socket.on("connect", connected)
    socket.on("disconnect", disconnected)
    socket.on("connect_error", disconnected)
    return () => {
      socket.off("connect", connected)
      socket.off("disconnect", disconnected)
      socket.off("connect_error", disconnected)
    }
  })
}
